import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import UpdatePlaceholderCommand from './updateplaceholdercommand';

export default class UpdatePlaceholderEditing extends Plugin {
    init() {
        const editor = this.editor;
        editor.commands.add('updateplaceholder', new UpdatePlaceholderCommand(editor, 'updateplaceholder'));
    }
}
